export const AUTHENTICATION = {
  LOGIN: 'auth/login/google',
  VERIFY: 'auth/verify/google',
};
